var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-primary mb-0"
        }, [_c('strong', [_vm._v("Job Library")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('CustomNav', {
          staticClass: "mb-4",
          attrs: {
            "items": _vm.tabs
          },
          on: {
            "item-click": function itemClick(tab) {
              return _vm.activeTab = tab;
            }
          }
        }), _vm.activeTab == 'per-category' ? [_c('CategoryJobLibraryList')] : [_c('JobLibraries')]];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }